/**
 * 
 * 
 * Reference:
 * https://codepen.io/juanbrujo/pen/KJdst?editors=0010
 * https://glidejs.com/
 * https://glidejs.com/docs/api/
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video
 * https://css-tricks.com/full-page-background-video-styles/
 * https://codepen.io/dudleystorey/pen/knqyK
 */

document.addEventListener("DOMContentLoaded", function() {

  var usvCultureSquaresBlock = document.querySelectorAll('.usv-culture-squares');
  var numberUsvCultureSquaresBlock = usvCultureSquaresBlock.length;

  for (let i = 0; i < numberUsvCultureSquaresBlock; i++) {

    /**
     * Enable the slider.
     */
    (function(cultureBlock){

      let previous = cultureBlock.querySelector('.usv-culture-squares__controls button.usv-culture-squares__control-previous');
      let next = cultureBlock.querySelector('.usv-culture-squares__controls button.usv-culture-squares__control-next');

      previous.addEventListener('click', blockPositionUpdate);
      next.addEventListener('click', blockPositionUpdate);

    })(usvCultureSquaresBlock[i]);

    function blockPositionUpdate(event) {

      let cultureSquares = event.target.parentNode.parentNode;
      let cultureBlocks = cultureSquares.querySelectorAll('.usv-culture-squares__block');
      let adjustment = Number(event.target.dataset.adjustment);

      for (let i = 0; i < cultureBlocks.length; i++) {
        
        let block = cultureBlocks[i];
        let position = Number(block.dataset.position);

        if(position+adjustment == 5) {
          block.setAttribute('data-position', 1);
        } else if (position+adjustment == 0) {
          block.setAttribute('data-position', 4);
        } else {
          block.setAttribute('data-position', adjustment + position);
        }
        
      }
    }
  }

});